import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import PropTypes from 'prop-types';
import React from 'react';
import {
  deleteMediaLiveChannel,
  startMediaLiveChannel,
  stopMediaLiveChannel,
} from 'utils/apiCalls';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

export default function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.Name}
        </TableCell>
        <TableCell align="right">{row.State}</TableCell>
        <TableCell align="right">{row.InputAttachments?.length}</TableCell>
        <TableCell align="right">{row.Destinations?.length}</TableCell>
        <TableCell align="right">
          <button onClick={() => startMediaLiveChannel(row.Id)}>Start</button>
          <button onClick={() => stopMediaLiveChannel(row.Id)}>Stop</button>
          <button onClick={() => deleteMediaLiveChannel(row.Id)}>Delete</button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              Inputs
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell align="right">Id</TableCell>
                      <TableCell align="right">End Behavior</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.InputAttachments.map((input) => {
                      return (
                        <TableRow key={input.InputId}>
                          <TableCell>{input.InputAttachmentName}</TableCell>
                          <TableCell align="right">{input.InputId}</TableCell>
                          <TableCell align="right">
                            {input.InputSettings.SourceEndBehavior}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              Destinations
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Id</TableCell>
                      <TableCell align="right">Stream Name</TableCell>
                      <TableCell align="right">URL</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.Destinations.map((destination) => (
                      <TableRow key={destination.Id}>
                        <TableCell>{destination.Id}</TableCell>
                        <TableCell align="right">{destination.Settings?.[0]?.StreamName}</TableCell>
                        <TableCell align="right">{destination.Settings?.[0]?.Url}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <div>
                <pre>{JSON.stringify(row, null, 2)}</pre>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    Name: PropTypes.string.isRequired,
    State: PropTypes.any,
    InputAttachments: PropTypes.array,
    Destinations: PropTypes.array,
    Id: PropTypes.string,
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      })
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
};
